export default __webpack_public_path__ + "static/media/etf white.a3102178.svg";